import { ICustomer } from "@/api/services/CustomerService";

export interface CustomerUIState {
  search: string;
  page: number;
  pageSize: number;
  sortBy: string;
  sortOrder: "asc" | "desc";
  user: ICustomer | null;

  setSearch: (search: string) => void;
  setPage: (page: number) => void;
  setPageSize: (size: number) => void;
  setSort: (sortBy: string, sortOrder: "asc" | "desc") => void;
  setUser: (user: ICustomer | null) => void;
}

export const createCustomerSlice = (set: any): CustomerUIState => ({
  search: "",
  page: 1,
  pageSize: 20,
  sortBy: "",
  sortOrder: "asc",
  user: null,

  setSearch: (search) => set({ search, page: 1 }),
  setPage: (page) => set({ page }),
  setPageSize: (pageSize) => set({ pageSize, page: 1 }),
  setSort: (sortBy, sortOrder) => set({ sortBy, sortOrder }),
  setUser: (user) => set({ user }),
});
